export const lineHeights = {
  text: 1.5,
  heading: 1.125
};
